import { render, staticRenderFns } from "./OrticTypeaheadControl.vue?vue&type=template&id=799270d4&"
import script from "./OrticTypeaheadControl.vue?vue&type=script&lang=js&"
export * from "./OrticTypeaheadControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports